// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';

// It does not dispatch any events on purpose.
// This action is a sync method and should not be used to trigger side effects.
export const refreshAppState =
	(newState: Partial<State>): Action<State> =>
	({ setState }) => {
		setState(newState);
	};
